import React from 'react'
import ReactDOM from 'react-dom/client'
import adapter from 'webrtc-adapter'
import * as Sentry from '@sentry/react'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import * as process from 'process'
import NotificationProvider from 'context/NotificationProvider'
import App from './App'
import config from 'config'
import './index.css'

window.global = window
window.process = process
window.Buffer = []
console.log(adapter.browserDetails.browser)

const isDevelopment = config.env === 'development'
const makeIntegrations = () => {
  let integrations = [
    Sentry.browserTracingIntegration(),
    Sentry.consoleLoggingIntegration({ levels: ['info', 'warn', 'error'] })
  ]
  if (isDevelopment) return integrations
  return integrations.concat(Sentry.replayIntegration())
}
Sentry.init({
  environment: config.env,
  dsn: 'https://8893aa8c416943cdbccdee66c8f07e54@o1069501.ingest.sentry.io/6064187',
  sendDefaultPii: true,
  integrations: makeIntegrations(),
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  tracesSampleRate: isDevelopment ? 0.1 : 1.0,
  enableLogs: true
})

const root = ReactDOM.createRoot(document.getElementById('root'))
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000
    }
  }
})

root.render(
  <QueryClientProvider client={queryClient}>
    <GoogleOAuthProvider clientId={config.google.clientId}>
      <NotificationProvider>
        <App />
      </NotificationProvider>
    </GoogleOAuthProvider>
  </QueryClientProvider>
)
